import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-notes-history',
    templateUrl: './notes-history.component.html',
    styleUrls: ['./notes-history.component.css'],
    standalone: false
})
export class NotesHistoryComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;

  token: any;
  items: any[] = [];
  description: any;
  patent_name: any;

  constructor(public utility: UtilitiesService, private modalService: NgbModal, public api: ApiService, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.patent_name = localStorage.getItem('patent_name');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;

      this.getItems(id);
    });
  }

  getItems(id: any) {
    this.utility.loading = true;
    const sub = this.api.get('notes/open/patient/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.items = objects.notes;

        this.list_length = this.items.length;

      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  open(content: any, text: any) {
    this.description = text;
    this.modalService.open(content);
  }

  close() {
    this.modalService.dismissAll()
  }

  getDoctor(id: any) {
    let objects = localStorage.getItem('doctors');

    if (objects) {
      let doctors = JSON.parse(objects);
      let doctor = doctors.find((i: { id: any; }) => i.id === id)

      if (doctor) return doctor.name;
      else return ''
    }
    else return ''
  }
}
